module.exports = __webpack_public_path__ + "static/img/ddjx-1.dc2e9685.png";